import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'

export default function ChatHeader({ onToggleSidebar }) {
  const navigate = useNavigate()
  const [showBorder, setShowBorder] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      setShowBorder(scrollTop > 0)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={`sticky top-0 z-30 bg-white flex items-center justify-between p-4 transition-all duration-200 ${showBorder ? 'border-b border-gray-200 shadow-sm' : ''}`}>
      <div className="flex items-center gap-3">
        {/* Hamburger Menu */}
        <button 
          onClick={onToggleSidebar}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
        
        <div>
          <h1 className="text-lg font-semibold text-gray-900">AI Inspect</h1>
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        {/* Close Button */}
        <button
          onClick={() => navigate('/')}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    </div>
  )
}
